import * as R from 'ramda';

import { UserDetail } from '@atom/types/user';
import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { maskUntilPos } from '@atom/utilities/stringUtilities';
import { isEmployeeIdMaskingEnabled } from '@atom/utilities/tenantFeatureUtilities';

import DetailRow from '../shared/DetailRow';

import sidebarClasses from '../shared/sidebars.module.css';

export type UserInfoTabProps = { user: UserDetail };

const UserInfoTab = ({ user }: UserInfoTabProps) => {
  const displayId =
    isEmployeeIdMaskingEnabled && user.employeeId
      ? maskUntilPos(user.employeeId)
      : user.employeeId;

  return (
    <div className={sidebarClasses.infoPanel}>
      <div className={sidebarClasses.infoDetailSection}>
        <DetailRow label="Employee ID" value={displayId} />
        <DetailRow label="Base Location" value={user.baseLocation} />
        <DetailRow label="Department" value={user.department} />
        <DetailRow label="Job Title" value={user.title} />
        <DetailRow
          label="Hourly Rate"
          value={R.isNil(user.rate) ? '' : numberToLocaleString(user.rate)}
        />
      </div>
    </div>
  );
};

export default UserInfoTab;
